


import {
  defineComponent,
  PropType,
  onMounted,
  computed,
  reactive,
} from '@vue/composition-api';
import type {
  EmergencyResponseTeamReportCar,
  EmergencyResponseTeamReport,
} from '@/models/externalReports/emergencyResponseTeam/spEmergencyResponseTeamReport';
import type {
  ExternalReportsLabelSp,
  ExternalReportSettings,
} from '@/models/apis/externalReports/external_report_settings';
import type {
  EmergencyResponseTeamReportBaseArrivalTsUpdateParams,
} from '@/models/apis/externalReports/emergencyResponseTeam/emergencyResponseTeamReportRequest';
import emergencyResponseTeamReportApi from '@/apis/externalReports/emergencyResponseTeam/emergency_response_team_report';
import emergencyResponseTeamCarApi from '@/apis/externalReports/emergencyResponseTeam/emergency_response_team_car';
import useSpeech from '@/composables/useSpeech';
import { useRequestGuard } from '@/composables/useRequestGuard';
import { useRoute } from '@/hooks/useRoute';

interface WorkingState {
  showConfirmStartWorkingModal: boolean;
  showConfirmTemporarilyStopWorkingModal: boolean;
  showConfirmStopWorkingModal: boolean;
  emergencyResponseTeamReport: EmergencyResponseTeamReport;
}
export default defineComponent({
  props: {
    emergencyResponseTeamCar: {
      type: Object as PropType<EmergencyResponseTeamReportCar>,
      required: true,
    },
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
  },
  emits: [
    'stopRunning',
    'showErrorOnCommon',
    'addPhoto',
  ],
  setup(props, { emit }) {
    const state = reactive<WorkingState>({
      showConfirmStartWorkingModal: false,
      showConfirmTemporarilyStopWorkingModal: false,
      showConfirmStopWorkingModal: false,
      emergencyResponseTeamReport: props.emergencyResponseTeamCar.report,
    });
    const { doSpeech } = useSpeech();
    const { router } = useRoute();
    const { doRequest, isRequesting } = useRequestGuard((errorMessage) => {
      emit('showErrorOnCommon', errorMessage);
    });

    const spLabels = computed<ExternalReportsLabelSp>(() => {
      return props.userSettings.sp;
    });

    const stopWorking = async() => {
      const params: EmergencyResponseTeamReportBaseArrivalTsUpdateParams = {
        operation_end_ts: new Date(),
        base_arrival_ts: new Date(),
      };
      state.showConfirmStopWorkingModal = false;
      await doRequest(async() => {
        state.emergencyResponseTeamReport = await emergencyResponseTeamReportApi.updateBaseArrival(
          state.emergencyResponseTeamReport.id,
          params,
        );
        await emergencyResponseTeamCarApi.updateReportId(props.emergencyResponseTeamCar.id, { current_report_id: null });
      }, '作業終了に失敗しました。再度操作を行ってください。');
      doSpeech(spLabels.value.message.confirm_end_work);
      emit('stopRunning', props.userSettings.choices.status.stopped.key, state.emergencyResponseTeamReport);
    };

    const addPhoto = () => {
      emit('addPhoto');
    };

    onMounted(() => {
      if (state.emergencyResponseTeamReport.id === 0) {
        router.push({name: 'Login'});
      }
    });

    return {
      state,
      isRequesting,
      spLabels,
      addPhoto,
      stopWorking,
    };
  },
});
